<template>
    <div 
        :class="[
            'consent-cancellation',
            { 'is-open': isOpen },
            { 'is-other-open': isOtherOpen }
        ]"
    >
        <div class="flex">
            <p 
                v-bastards 
                class="fs-18 paragraph-max-width"
            >
                Chcielibyśmy usprawnić naszą komunikację marketingową, dlatego też prosimy o podanie powodu Twojej
                rezygnacji:
            </p>
            <div>
                <Dropdown 
                    ref="dropdown"
                    :is-required="true"
                    :items="causes"
                    @change="onChangeCause"
                />
                <InputText 
                    v-model="causeOtherInput"
                    ref="causeOtherInput"
                    :is-required="true"
                    :class="[
                        'consent-cancellation-reason-other'
                    ]"
                />
            </div>
        </div>
        <!-- <div class="flex">
            <div>
                <p class="fs-18 text-paragraph">
                    <strong v-bastards>Jesteś pewien?</strong>
                </p>
                <p v-bastards class="fs-18 paragraph-max-width-bigger">
                    Pamiętaj, że dzięki zgodzie na komunikację email <strong>będziesz na bieżąco ze wszystkimi ofertami specjalnymi MAKRO</strong>. A co tydzień otrzymasz od nas <strong>specjalne i dedykowane dla Ciebie oferty</strong>
                </p>
            </div>
            <div>
                <RadioGroup 
                    :name="`${label}-cancellation`" 
                    :selected="1" 
                    :options="[
                        {
                            label: 'NIE, zmieniłem zdanie',
                            value: 0
                        },
                        {
                            label: 'TAK, chcę zrezygnować',
                            value: 1
                        }
                    ]"
                    theme="compact"
                    @change="onChangeMind"
                />
            </div>
        </div> -->
    </div>
</template>

<script>
import Dropdown from '@/components/dropdown/Dropdown'
import InputText from '@/components/form/InputText'
// import RadioGroup from '@/components/form/RadioGroup'

export default {
    components: {
        Dropdown,
        InputText,
        // RadioGroup
    },

    props: {
        label: {
            type: String,
            required: false,
            default: ''
        },
        isOpen: {
            type: Boolean,
            required: false,
            default: false
        },
        causes: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            causeOtherInput: '',
            currentValue: null,
            isOtherOpen: false
        }
    },

    watch: {
        causeOtherInput: function(otherInput) {
            if (this.currentValue !== 0) {
                return
            }

            this.$emit('input', {
                value: this.currentValue,
                label: otherInput
            })
        }
    },

    methods: {
        onChangeMind(value) {
            this.$emit('changeMind', value)
        },

        onChangeCause(value) {
            let valueCopy = Object.assign({}, value)

            if (valueCopy.value === 0) {
                valueCopy.label = this.causeOtherInput

                this.isOtherOpen = true
                this.$refs.causeOtherInput.$el.querySelector('input').focus()
            }
            else {
                this.isOtherOpen = false
            }

            this.currentValue = valueCopy.value
            
            this.$emit('input', valueCopy)
        },

        validate() {
            return (this.$refs.dropdown.validate() && this.currentValue !== 0) || this.$refs.causeOtherInput.validate()
        }
    }
}
</script>

<style lang="scss">
.consent-cancellation {
    @include hide();
    @include transition(opacity .200s ease-in-out, visibility .200s ease-in-out);
    max-height: 0;

    &.is-open {
        @include show();
        max-height: none;
        padding: 15px 0 0;
    }

    strong {
        font-weight: $font-weight-bold;
    }

    .paragraph-max-width {
        max-width: 650px;
        padding-right: 20px;

        &-bigger {
            max-width: 750px;
            padding-right: 20px;
        }
    }

    > * {
        &.flex {
            padding: 0 0 35px;

            & + .flex {
                position: relative;
                padding: 35px 0 57px;

                &:before {
                    content: '';
                    background-color: $color-border;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    height: 1px;
                }
            }

            > * {
                &:nth-child(2) {
                    position: relative;
                }
            }
        }
    }

    &-reason {
        &-other {
            @include transition(all 0s linear 0s);
            position: absolute;
            width: 100%;
            margin-top: 10px;
            opacity: 0;
        }
    }

    &.is-other-open {
        > * {
            &.flex {
                padding: 0 0 65px;
            }
        }

        .consent-cancellation-reason-other {
            @include transition(.200s);
            opacity: 1;
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        > * {
            &.flex {
                display: block;

                > * {
                    &:first-child {
                        padding-bottom: 25px;
                    }

                    .dropdown {
                        > select {
                            min-width: unset;
                        }
                    }
                }
            }
        }
    }
}
</style>
